import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4fdb20a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "page" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "text-center-desktop container" }
const _hoisted_5 = { class: "subtitle subtitle--left--mobile text-primary" }
const _hoisted_6 = { class: "lead" }
const _hoisted_7 = { class: "content intro" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing" }, null, -1))
const _hoisted_9 = { class: "bg-light text-center-desktop" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing" }, null, -1))
const _hoisted_11 = { class: "container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator--center--desktop" }, null, -1))
const _hoisted_13 = { class: "images-grid content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacing" }, null, -1))
const _hoisted_16 = { class: "gallery" }
const _hoisted_17 = { class: "container text-center-desktop" }
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "subtitle subtitle--left--mobile text-primary" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"2.25rem","font-weight":"700","color":"var(--primary)"} }, [
  /*#__PURE__*/_createElementVNode("span", { "data-counter": "917000" }, "0"),
  /*#__PURE__*/_createTextVNode(" PLN ")
], -1))
const _hoisted_21 = { class: "container gallery__items" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_23 = { class: "lead" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_headline = _resolveComponent("page-headline")!
  const _component_thumb = _resolveComponent("thumb")!
  const _component_home_our_people = _resolveComponent("home-our-people")!
  const _component_launch_your_product = _resolveComponent("launch-your-product")!

  return (_ctx.page)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_page_headline, { content: _ctx.page }, null, 8, ["content"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.page.overSubtitle), 1),
              _createElementVNode("h2", null, _toDisplayString(_ctx.page.subtitle), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.page.subtitleDescription), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_thumb, {
                  file: _ctx.page?.additionalThumb1,
                  size: 'large'
                }, null, 8, ["file"])
              ]),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("h2", null, _toDisplayString(_ctx.timeTogether.title), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeTogether?.lead?.split('\n'), (paragraph, i) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: i,
                  class: "lead",
                  style: {"margin-bottom":"8px"}
                }, _toDisplayString(paragraph), 1))
              }), 128)),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_thumb, {
                  file: _ctx.timeTogether?.thumb,
                  size: 'large'
                }, null, 8, ["file"]),
                _createVNode(_component_thumb, {
                  file: _ctx.timeTogether?.additionalThumb1
                }, null, 8, ["file"]),
                _createVNode(_component_thumb, {
                  file: _ctx.timeTogether?.additionalThumb2
                }, null, 8, ["file"]),
                _createVNode(_component_thumb, {
                  file: _ctx.timeTogether?.additionalThumb3
                }, null, 8, ["file"]),
                _createVNode(_component_thumb, {
                  file: _ctx.timeTogether?.additionalThumb4
                }, null, 8, ["file"]),
                _createVNode(_component_thumb, {
                  file: _ctx.timeTogether?.additionalThumb5
                }, null, 8, ["file"]),
                _createVNode(_component_thumb, {
                  file: _ctx.timeTogether?.additionalThumb6
                }, null, 8, ["file"])
              ])
            ]),
            _hoisted_14,
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.localCharities.overSubtitle), 1),
                _createElementVNode("h2", null, _toDisplayString(_ctx.localCharities.title), 1),
                _hoisted_20,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localCharities?.lead?.split('\n'), (paragraph, i) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: i,
                    class: "lead",
                    style: {"margin-bottom":"8px"}
                  }, _toDisplayString(paragraph), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localCharities?.bullets, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_thumb, {
                      file: _ctx.localCharities?.['additionalThumb' + (index + 1)]
                    }, null, 8, ["file"])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_22,
                    _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                    _createElementVNode("p", _hoisted_23, _toDisplayString(item.description), 1)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode(_component_home_our_people),
        _createVNode(_component_launch_your_product)
      ]))
    : _createCommentVNode("", true)
}